import { FeatureType } from "@seneca/trials-service-client/dist/types";

import actionTypes from "../../../../action-types";
import makeTrialReducer from "../trial";

export default makeTrialReducer({
  featureType: FeatureType.WRONG_ANSWERS,
  recordTrialEventActionType: actionTypes.STUDY_WRONG_ANSWER_SESSION
});
